import {
  FormConfig,
  IBasicSearchPaginationProps,
  Widget,
} from 'src/app/shared/models/dynamic.model';
import {
  ComponentMapping,
  IManifestDetailsData,
  IManifestInformationData,
  IManifestRequiredBagData,
  ManifestBagGridColumnData,
  TableColumns,
  TimelineDataItem,
  ManifestColumnData
} from '../../model/manifest.model';
import { TableColumnsProp } from 'src/app/shared/models/tables.model';
import { ACCORDION_TAB_SHORTCUTS_NOTES_TO_DETAILS } from 'src/app/shared/config/information-accordion-tab-shortcuts.config';
import { DataTableConfig } from 'src/app/shared/components/data-table';
import {
  AccordionTabs,
  BulkDeleteItemNames,
  GridColumnsStorageNames,
  MessageTemplates,
  searchDataParam,
  validationErrorMessages,
} from 'src/app/shared/utility/constants';

export const widgets: Widget[] = [
  {
    id: 1,
    title: 'Number of Bags',
    value: '--',
    extraClasses: 'pt-6',
    iconName: 'bagNumbers',
    name: 'noOfBags',
    controlName: 'noOfBags',
  },
  {
    id: 2,
    title: 'Number of Shipments',
    value: '--',
    extraClasses: 'pt-6',
    iconName: 'hawbNumbers',
    name: 'noOfHawbs',
    controlName: 'noOfShipment',
  },
  {
    id: 3,
    title: 'Total Weight',
    value: '--',
    extraClasses: 'pt-6',
    iconName: 'weight',
    name: 'totalWeight',
    controlName: 'totalWeight',
  },
];

/* Manifest Information Form Fields Configuration */
export const manifestInfoFormFieldsConfig: FormConfig = {
  fields: [
    {
      id: 'manifestDate',
      type: 'input',
      label: 'Manifest Date',
      required: true,
      requiredError: 'Manifest Date should be in MM-DD-YYYY',
    },
    {
      id: 'originName',
      type: 'input',
      label: 'Origin',
      required: true,
      requiredError: 'Origin is required',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'origin',
      type: 'input',
      label: 'Origin',
    },
    {
      id: 'destinationName',
      type: 'input',
      label: 'Destination',
      required: true,
      requiredError: 'Destination is required',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'destination',
      type: 'input',
      label: 'Destination',
    },
    {
      id: 'agentName',
      type: 'input',
      label: 'Agent',
      minValue: 1,
      maxValue: 126,
      isCheckForMaxValue: true,
    },
    {
      id: 'agentId',
      type: 'input',
      label: 'Agent',
    },
    {
      id: 'mawbExt',
      type: 'input',
      label: 'Mawb',
      minValue: 11,
      maxValue: 11,
      minError: '11 numbers is required',
      allowNumeric: true,
    },
    {
      id: 'mawbId',
      type: 'input',
      label: 'Mawb Id',
    },
    {
      id: 'airlineName',
      type: 'input',
      label: 'Airline',
      isDisableField: true,
    },
    {
      id: 'airlineId',
      type: 'input',
      label: 'Airline',
    },
    {
      id: 'flightNumber',
      type: 'input',
      label: 'Flight Number',
      requiredError: 'Flight Number is required',
      isDisableField: true,
    },
    {
      id: 'flightAirlineName',
      type: 'input',
      label: 'Flight Airline Name',
    },
    {
      id: 'flightAirlineId',
      type: 'input',
      label: 'Flight Data',
    },
    {
      id: 'manifestId',
      type: 'input',
      label: 'Manifest',
      isDisableField: true,
    },
    {
      id: 'manifestNumber',
      type: 'input',
      label: 'Manifest',
      minValue: 3,
      maxValue: 126,
      required: true,
      requiredError: 'Manifest Number is required',
      minError: 'Invalid Manifest Number entered',
      isDisableField: false,
      allowAlphaNumericWithDotUnderscoreDashSpecialCharacters: true,
    },
    {
      id: 'information',
      type: 'input',
      label: 'Information',
      noInitialWhiteSpace: true,
    },
  ],
};

/* Manifest Timeline Configuration */
export const timelineData: TimelineDataItem[] = [
  {
    date: '3/21/2024',
    time: '11:11:11',
    event: 'Manifest updated',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Notes updated',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Notes added',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Manifest created',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Bag details edited',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Bag attachment added',
  },
];

/* Component Mappings Configuration */
export const componentMappings: ComponentMapping[] = [
  { title: AccordionTabs.StatusCodes, componentType: '' },
  { title: 'Notes', componentType: '' },
  { title: 'Events', componentType: '' },
  { title: 'Attachments', componentType: '' },
  { title: 'Details', componentType: '' },
];

export const INFORMATION_ACCORDION_TAB_SHORTCUTS: Readonly<
  Record<string, string>
> = { ...ACCORDION_TAB_SHORTCUTS_NOTES_TO_DETAILS };

/* Piece Grid Input Row Data Configuration */
export const bagsGridInputRowData: ManifestBagGridColumnData[] = [
  {
    bagId: '',
    bagExt: '',
    shipments: 0,
    weight: '',
    isInputRow: true,
  },
];

/* Bag Table Grid Columns Configuration */
export const bagTableGridColumns = [
  { key: 'bagExt', label: 'Bag', isSelected: true, defaultPrintWidth: 150 },
  {
    key: 'shipments',
    label: 'Shipments',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'weight',
    label: 'Weight (lb)',
    isSelected: true,
    defaultPrintWidth: 120,
  },
];

export const manifestMultipleBagSelectionGridColumns = [
  { key: 'bagExt', label: 'Bag Ext', isSelected: true },
  { key: 'origin', label: 'Origin', isSelected: true },
  { key: 'destination', label: 'Destination', isSelected: true },
  { key: 'shipments', label: 'Shipments', isSelected: true },
  { key: 'weight', label: 'Weight', isSelected: true },
  { key: 'mawb', label: 'MAWB', isSelected: true },
];

export const defaultManifestBagData = (): IManifestRequiredBagData[] => [
  {
    bagExt: '',
    weight: '',
    shipments: 0,
    action: '',
  },
];

export const defaultManifestInfoData = (): IManifestDetailsData => ({
  manifestDate: '',
  originName: '',
  origin: 0,
  destinationName: '',
  destination: 0,
  agentName: '',
  agentId: 0,
  mawbExt: 0,
  airline: '',
  flightNumber: '',
  manifestId: 0,
  information: '',
});

export const defaultManifestInformationData = (): IManifestInformationData => ({
  manifestDate: '',
  origin: 0,
  destination: 0,
  mawbExt: 0,
  airlineName: '',
  information: '',
  flightNumber: '',
  manifestId: 0,
  manifestExt: '',
  details: {
    mawbId: 0,
  },
  notes: {
    ibc: [],
    customer: [],
  },
  bags: defaultManifestBagData(),
  agentName: '',
  originName: '',
  destinationName: '',
});

export const manifestDetailRequiredKeys = [
  'manifestDate',
  'origin',
  'destination',
  'mawbExt',
  'airlineName',
  'information',
  'manifestId',
  'agentId',
  'flights',
  'agentName',
  'manifestExt',
];

// manifest summary
export const searchFormfieldsConfig: FormConfig = {
  fields: [
    {
      id: 'manifestDate',
      type: 'input',
      label: 'Manifest Date',
      minValue: 1,
      maxValue: 11,
      allowNumeric: true,
    },
    {
      id: 'manifestNo',
      type: 'input',
      label: 'Manifest Number',
      minValue: 1,
      maxValue: 14,
      allowNumeric: true,
    },
    {
      id: 'originId',
      type: 'input',
      label: 'Origin',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'destinationId',
      type: 'input',
      label: 'Destination',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'agentName',
      type: 'input',
      label: 'Agent Name',
    },
    {
      id: 'agentCode',
      type: 'input',
      label: 'Agent Number',
    },
    {
      id: 'airlineCode',
      type: 'input',
      label: 'Airline Number',
    },
    {
      id: 'mawbExt',
      type: 'input',
      label: 'MAWB',
      allowNumeric: true,
      minValue: 1,
      maxValue: 14,
    },
    {
      id: 'airlineName',
      type: 'input',
      label: 'Airline',
    },
    {
      id: 'flightNumber',
      type: 'input',
      label: 'Flight',
      minValue: 1,
      maxValue: 6,
      allowAlphaNumeric: true,
    },
  ],
};

export const gridSummaryColumns: TableColumns[] = [
  {
    isSelected: true,
    defaultView: true,
    isEditable: false,
    key: 'date',
    label: 'Date',
    value: 'date',
    defaultPrintWidth: 150,
  },
  {
    key: 'manifestNo',
    label: 'Manifest Number',
    value: 'manifestNo',
    isSelected: true,
    defaultView: true,
    isEditable: false,
    defaultPrintWidth: 130,
  },
  {
    value: 'origin',
    isSelected: true,
    defaultView: true,
    key: 'origin',
    label: 'Origin',
    isEditable: false,
    defaultPrintWidth: 100,
  },
  {
    defaultView: true,
    isEditable: false,
    key: 'destination',
    label: 'Destination',
    value: 'destination',
    isSelected: true,
    defaultPrintWidth: 100,
  },
  {
    value: 'noOfBags',
    isEditable: false,
    isSelected: true,
    defaultView: true,
    key: 'noOfBags',
    label: 'Bags',
    defaultPrintWidth: 100,
  },
  {
    isSelected: true,
    defaultView: true,
    isEditable: false,
    key: 'isPublished',
    label: 'Published',
    value: 'isPublished',
    defaultPrintWidth: 100,
  },
  {
    isEditable: false,
    value: 'agentCode',
    isSelected: true,
    key: 'agentCode',
    label: 'Agent Code',
    defaultView: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'mawbExt',
    label: 'MAWB',
    isSelected: true,
    value: 'mawbExt',
    defaultView: true,
    isEditable: false,
    defaultPrintWidth: 150,
  },
  {
    key: 'airlineCode',
    label: 'Airline Code',
    value: 'airlineCode',
    isSelected: true,
    defaultView: true,
    isEditable: false,
    defaultPrintWidth: 130,
  },
  {
    isSelected: false,
    defaultView: false,
    isEditable: false,
    key: 'agentName',
    label: 'Agent Name',
    value: 'agentName',
    defaultPrintWidth: 120,
  },
];

export const manifestExcelColumns = [
  'date',
  'manifestNo',
  'origin',
  'destination',
  'noOfBags',
  'isPublished',
  'agentCode',
  'mawbExt',
  'airlineCode',
  'agentName',
];

export const defaultGridDisplayColumns = [
  'select',
  ...manifestExcelColumns,
  'action',
];

export const ManifestExcelHeaders: string[] = [
  'Date',
  'Manifest Number',
  'Origin',
  'Destination',
  'Bags',
  'Published',
  'Agent Code',
  'MAWB',
  'Airline Code',
  'Agent Name',
];

export const defautPagination = {
  fromIndex: 0,
  toIndex: 10,
  sortingOrder: searchDataParam.desc,
  sortingField: searchDataParam.manifestId,
};

export const reduceWidthForFields = {
  manifestFlightNumber: 16,
  manifestFlightNumberHelp: 12,
};

export const fieldControlNames = {
  manifestFlightNumber: 'manifest-flightNumber',
  manifestFlightNumberHelp: 'manifest-flightNumber-help',
};

export const ManifestSearchConfig: IBasicSearchPaginationProps =
  defautPagination;

export const manifestDataTableConfig: DataTableConfig<ManifestColumnData> = {
  rowIdField: 'manifestId',
  entityName: BulkDeleteItemNames.Manifests,
  storageKey: GridColumnsStorageNames.manifest,
  columns: [
    {
      key: 'date',
      label: 'Date',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 150,
    },
    {
      key: 'manifestNo',
      label: 'Manifest Number',
      isSelected: true,
      defaultView: true,
      sortable: true,
      isHyperlink: true,
      defaultPrintWidth: 130,
      showTooltip: true,
    },
    {
      key: 'origin',
      label: 'Origin',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 100,
    },
    {
      key: 'destination',
      label: 'Destination',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 100,
    },
    {
      key: 'noOfBags',
      label: 'Bags',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 100,
    },
    {
      key: 'isPublished',
      label: 'Published',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 100,
    },
    {
      key: 'agentCode',
      label: 'Agent Code',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 120,
    },
    {
      key: 'mawbExt',
      label: 'MAWB',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 150,
      showTooltip: true,
    },
    {
      key: 'airlineCode',
      label: 'Airline Code',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 130,
    },
    {
      key: 'agentName',
      label: 'Agent Name',
      isSelected: false,
      defaultView: false,
      sortable: true,
      defaultPrintWidth: 120,
      showTooltip: true,
    },
  ],
  features: {
    selection: true,
    pagination: true,
    sorting: true,
    columnReorder: true,
    selectAllAcrossPages: true,
    columnCustomization: true,
  },
  messages: {
    noSearch: validationErrorMessages.manifestBeforeSearch,
    noMatch: validationErrorMessages.manifestAfterSearch,
    allPageSelected: MessageTemplates.AllItemsSelected,
    selectAll: MessageTemplates.SelectAllItems,
  },
  defaultPagination: {
    pageSize: defautPagination.toIndex - defautPagination.fromIndex,
    sortField: searchDataParam.manifestId as keyof ManifestColumnData,
    sortDirection: 'desc',
  },
};

export const ManifestInfoSectionHeaders: string[] = [
  'Widgets',
  'Manifest Information',
  'Notes',
  'Events',
  'Attachments',
  'Details',
  'Bag(s) linked',
];

export const ManifestInfoSectionHeaderKeys: string[] = [
  'widgets',
  'manifestInfo',
  'notes',
  'events',
  'attachments',
  'details',
  'manifestsBags',
];

export const ManifestInfoHeaders = [
  {
    key: 'manifestDate',
    label: 'Manifest Date',
    isSelected: true,
    defaultPrintWidth: 130,
  },
  {
    key: 'originName',
    label: 'Origin',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'destinationName',
    label: 'Destination',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'agentName',
    label: 'Agent',
    isSelected: true,
    defaultPrintWidth: 130,
  },
  {
    key: 'mawbExt',
    label: 'MAWB',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'airlineName',
    label: 'MAWB Airline',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'flightNumber',
    label: 'Flight',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'flightAirlineName',
    label: 'Flight Airline',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'manifestId',
    label: 'Manifest Number',
    isSelected: true,
    defaultPrintWidth: 130,
  },
];

export const ManifestDetailsHeaders = [
  {
    key: 'manifestId',
    label: 'Manifest ID',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'mawbId',
    label: 'MAWB ID',
    isSelected: true,
    defaultPrintWidth: 150,
  },
];

export const manifestWidgetTableGridColumns = [
  {
    key: 'noOfBags',
    label: 'Number of Bags',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'noOfHawbs',
    label: 'Number of Shipments',
    isSelected: true,
    defaultPrintWidth: 180,
  },
  {
    key: 'totalWeight',
    label: 'Total Weight',
    isSelected: true,
    defaultPrintWidth: 150,
  },
];

export const ManifestHeldReportExcelHeaders = [
  'Shipment',
  'Weight' ,
  'Value',
  'Shipper' ,
  'Consignee' 
]

export const ManifestHeldReportKeys = [
  'shipment',
  'weight' ,
  'value',
  'shipper' ,
  'consignee' 
]
export const bagLinkedTableColumns = [
  {
    key: 'bagExt',
    label: 'Bag',
    defaultPrintWidth: 80,
    isSelected: true,
  },
  {
    key: 'bagWeight',
    label: 'Weight (lb)',
    defaultPrintWidth: 60,
    isSelected: true,
  },

  // Shipment Information
  {
    key: 'shipmentExt',
    label: 'Shipment',
    defaultPrintWidth: 100,
    isSelected: true,
  },
  {
    key: 'origin',
    label: 'Origin',
    defaultPrintWidth: 80,
    isSelected: true,
  },
  {
    key: 'destination',
    label: 'Destination',
    defaultPrintWidth: 80,
    isSelected: true,
  },
  {
    key: 'shipmentWeight',
    label: 'Weight (lb)',
    defaultPrintWidth: 60,
    isSelected: true,
  },
  {
    key: 'shipperInfo',
    label: 'Shipper Information',
    defaultPrintWidth: 220,
    isSelected: true,
  },
  {
    key: 'consigneeInfo',
    label: 'Consignee Information',
    defaultPrintWidth: 220,
    isSelected: true,
  },

  // Commodity Details (single column – formatting later on print page)
  {
    key: 'commodityDetails',
    label: 'Commodity Details',
    defaultPrintWidth: 260,
    isSelected: true,
  },
];

export {
  bagColumns,
  shipmentColumns,
  commodityColumns,
} from 'src/app/shared/configs/entity-print.config';

export const manifestPublishFormatColumns: TableColumnsProp[] = [
  { key: 'displayName', label: 'Attachment', isSelected: true, defaultView: true, disableSort: true },
  { key: 'attachmentActions', label: 'Actions', isSelected: true, defaultView: true, disableSort: true },
];
